<div class="main-wrapper ">
<app-navbar></app-navbar>

<div class="our-story-container">
  <!-- <div class="content-wrapper"> -->
    <div class="left">
      <app-brochure-button
         fileName="About us.pdf"
         label="Download Brochure"
         className="dark-btn">
      </app-brochure-button>

    <h2>Lyssa deHart</h2>
    <p>Lyssa deHart, LICSW, MCC, BCC, EMCC, is a respected author, coaching educator, and "recovering therapist." She wrote StoryJacking: Change Your Dialogue, Transform Your Life, The Reflective Coach, and Light Up: The Science of Coaching with Metaphors, and the upcoming Sticky Outcomes. Lyssa is the host The Coaching Studio Podcast, where she engages in thought-provoking conversations with thought leaders in the coaching and psychology profession.</p>
    <ul>
      <li>
        <i class="fa-solid fa-star"></i>
        <strong>Proven Success Strategies:</strong>
        <p class="nested-p">Strategies for professionals seeking career advancement.</p>
      </li>
      <li>
        <i class="fa-solid fa-star"></i>
        <strong>Customized Coaching Plans:</strong>
        <p class="nested-p">Designed with individual goals in mind.</p>
      </li>
      <li>
        <i class="fa-solid fa-star"></i>
        <strong>Access to a Network:</strong>
        <p class="nested-p">Connect with industry leaders and lifelong learning resources.</p>
      </li>
    </ul>
  </div>
  <div class="right">
    <img src="../../../assets/Lyssa deHart.jpg" alt="NexGen Executive Coaching Academy Team" />
  </div>
  <!-- </div> -->
</div>

<div class="our-values-container">
  <div class="left2">
    <!-- <a href="https://youtu.be/Ktw2Ssdi7Co?si=V0vHXPGz9KT8uGKX" target="_blank"> -->
       <iframe
    *ngIf="videoUrl"
    [src]="videoUrl"
    class="video-placeholder"
    width="100%"
    height="100%"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen>
  </iframe>
    <!-- </a> -->
  </div>
  <div class="right2">
    <div class="about">
      <div class="line"></div>
      <h4>Our Values</h4>
      <div class="line"></div>
    </div>
    <h2>Our Core Values</h2>
    <p class="coaching-text">At NexGen Executive Coaching Academy, our core values shape everything we do. We prioritize integrity and foster a culture of trust and accountability that empowers both instructors and students.</p>
    <ul>
      <li>
        <i class="fa-solid fa-star"></i>
        <strong>Integrity:</strong>
        <p class="nested-p">Upholding honesty and ethics in all coaching practices.</p>
      </li>
      <li>
        <i class="fa-solid fa-star"></i>
        <strong>Excellence:</strong>
        <p class="nested-p">Delivering the highest quality in education and personal development.</p>
      </li>
      <li>
        <i class="fa-solid fa-star"></i>
        <strong>Community:</strong>
        <p class="nested-p">Building a supportive network for lifelong learning and growth.</p>
      </li>
    </ul>
    <button routerLink="/platinum-package">Discover More</button>
  </div>
</div>

<div class="expert-container">
  <div class="heading">
    <h2>Real-World Experts. Transformational Coaches. Global Leaders.</h2>
    <p>
       Our instructors are certified executive coaches, leadership consultants, and Fortune 500 professionals who bring decades of real-world business, leadership, and coaching experience into every session.
    </p>
  </div>
  <div class="cards d-flex">
    <div class="card" *ngFor="let member of teamMembers">
  <img [src]="member.imageUrl" alt="">

  <div class="data">
    <h5>{{member.name}}</h5>
    <h6>{{member.title}}</h6>

    <p>
      {{ member.showFullDescription ? member.description : (member.description | slice:0:40) + '...' }}
    </p>

    <button class="see-more-btn"
            *ngIf="!member.showFullDescription"
            (click)="member.showFullDescription = true">
      See more
    </button>

    <button class="see-more-btn"
            *ngIf="member.showFullDescription"
            (click)="member.showFullDescription = false">
      See less
    </button>
  </div>
</div>

  </div>
</div>

<div class="enrollment-container">
  <div class="enrollment-header">
    <h4>Enrollment Process: Simple & Straightforward</h4>
    <p>We’ve made the enrollment process seamless so you can focus on what truly matters.</p>
  </div>
  <div class="contant">
    <div class="left">
      <h4>Choose Your Certification Program</h4>
      <p>Platinum, Gold</p>
      <p class="sub-text"><strong>Register Online</strong>  <label> Secure Your Spot in the Program</label></p>
      <p class="sub-text"><strong>Access Training</strong>  <label> Materials & Start Learning</label></p>
      <p class="sub-text"><strong>Attend Live Webinars</strong>  <label> & Practice Coaching Sessions</label></p>
      <p class="sub-text"><strong>Complete Certification</strong>  <label> & Begin Your Coaching Career.</label></p>
      <button routerLink="/platinum-package">Enroll Now <i class="fa-solid fa-greater-than"></i></button>
    </div>
    <div class="right">
      <img src="../../../assets/certification-program.jpeg" alt="">
    </div>
  </div>
</div>

<div class="accadmy-lms-container">
  <h4>NexGen Executive Coaching Academy LMS Platform:</h4>
  <h5>A Cutting-Edge Learning Experience</h5>
  <div class="contant">
    <div class="left">
       <iframe
    *ngIf="videoUrl"
    [src]="videoUrl"
    class="video-placeholder"
    width="100%"
    height="100%"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen>
  </iframe>   
    </div>
    <div class="right">
      <h5>Our state-of-the-art LMS platform provides everything you need to succeed in executive coaching:</h5>
      <ul>
        <li><i class="fa-solid fa-check"></i> 24/7 access to training modules, recorded webinars & coaching materials</li>
        <li><i class="fa-solid fa-check"></i> AI-powered coaching assistant for simulated practice</li>
        <li><i class="fa-solid fa-check"></i> Interactive learning tools & on-demand coaching support</li>
        <li><i class="fa-solid fa-check"></i> Live Zoom webinars (Monday–Friday evenings & Saturday afternoons)</li>
      </ul>
    </div>
  </div>
</div>

<div class="our-plateform-container">
  <div class="our-plateform-header">
    <h4>Why Our Platform Stands Out</h4>
    <p>We believe that continuous learning and professional development are key to success in executive coaching.</p>
  </div>

  <div class="contant">
    <div class="card" *ngFor="let item of plateformCards">
  <img [src]="item.img" alt="">
  <div class="cardContant">
    <h3>{{item.head}}</h3>
    <p>{{item.para}}</p>
  </div>

  <ng-container *ngIf="item.isExternalLink; else internalRouterLink">
    <button>
      <a [href]="item.route" target="_blank" style="text-decoration: none;color: white;">
         {{item.button}}
      </a>
    </button>
  </ng-container>

  <ng-template #internalRouterLink>
    <button [routerLink]="item.route">{{item.button}}</button>
  </ng-template>
</div>
  </div>
</div>

<div class="contact-container">
  <div class="contact-wrapper">
    <div class="left">
      <h2>Contact our team</h2>
      <p>
        Got any questions about the product or scaling on our platform? We’re here to help.
        Chat to our friendly team 24/7 and get onboard in less than 5 minutes.
      </p>

    <form [formGroup]="userForm" (ngSubmit)="submitForm2()" class="contact-form">
  <div class="name-group">
    <div class="form-field">
      <label>First name</label>
      <input type="text" formControlName="firstName" placeholder="First name" />
    </div>
    <div class="form-field">
      <label>Last name</label>
      <input type="text" formControlName="lastName" placeholder="Last name" />
    </div>
  </div>

  <div class="form-field">
    <label>Email</label>
    <input type="email" formControlName="email" placeholder="you@company.com" />
  </div>

  <div class="form-field">
    <label>Message</label>
    <textarea formControlName="message" rows="5" placeholder="Leave us a message..."></textarea>
  </div>

  <button type="submit" [disabled]="isSubmitting || userForm.invalid">
    {{ isSubmitting ? 'Sending...' : 'Send message' }}
  </button>
</form>

    </div>

    <div class="right">
      <h3>Chat with us</h3>
      <ul>
        <!-- <li>💬 Start a live chat</li>
        <li>📧 Shoot us an email</li> -->
        <li>💭 Message us on X</li>
      </ul>

      <h3>Call us</h3>
      <p>+1 (555) 000-0000</p>

      <h3>Visit us</h3>
      <p>100 Smith Street, Collingwood VIC 3066</p>
    </div>
  </div>
</div>


<app-footer></app-footer>

</div>